import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Alert, Form, Modal } from "antd";
import React, { useState } from "react";
import axios from "axios";
import { axiosErrorHandler, isConcurrentModificationError } from "../../../../swzutils";
import ConsignmentCommunicationChannelsFormItems from "./ConsignmentCommunicationChannelsFormItems";
const ConsignmentCommunicationChannelsModal = (props) => {
    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false);
    const [errorMessage, setErrorMessage] = useState(null);
    const patchDelivery = (formValues) => {
        setLoading(true);
        axios.patch(`/admin/v1/consignments/${props.consignment.id}`, {
            version: props.consignment.version,
            scheduledCommunicationChannels: formValues.scheduledCommunicationChannels,
            startedCommunicationChannels: formValues.startedCommunicationChannels,
            completedCommunicationChannels: formValues.completedCommunicationChannels,
        }).then(response => {
            props.onUpdated(response.data);
        }).catch(error => {
            if (isConcurrentModificationError(error)) {
                setErrorMessage("The delivery date could not be updated. This is because another user has updated the same consignment.  Please refresh the consignment list and try again.");
            }
            else {
                axiosErrorHandler(error, setErrorMessage);
            }
        }).finally(() => setLoading(false));
    };
    return (_jsxs(Modal, { title: "Delivery Communication Channels", open: props.open, okText: "Update", onOk: form.submit, onCancel: () => {
            setErrorMessage(null);
            props.onCancel();
        }, confirmLoading: loading, destroyOnHidden: true, children: [_jsx(Form, { form: form, onFinish: patchDelivery, labelCol: { span: 8 }, wrapperCol: { span: 16 }, initialValues: {
                    'scheduledCommunicationChannels': (props.consignment.scheduledCommunicationChannels == null) ? ['EMAIL', 'SMS'] : props.consignment.scheduledCommunicationChannels,
                    'startedCommunicationChannels': props.consignment.startedCommunicationChannels || [],
                    'completedCommunicationChannels': props.consignment.completedCommunicationChannels || []
                }, children: _jsx(ConsignmentCommunicationChannelsFormItems, {}) }), errorMessage ?
                _jsx(Alert, { title: errorMessage, type: "error", showIcon: true }) : null] }));
};
export default ConsignmentCommunicationChannelsModal;
